import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "return-final",
  "use": "return-final-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 15\" id=\"return-final\"><path d=\"M0 7.5C0 11.644 3.352 15 7.496 15A7.501 7.501 0 100 7.5zm1.5 0c0-3.315 2.685-6 6-6s6 2.685 6 6-2.685 6-6 6-6-2.685-6-6zm5.275 2.923a.607.607 0 01-.496-.254l-1.27-1.708a.598.598 0 01.128-.853.598.598 0 01.853.126l.774 1.05 2.515-3.38c.196-.277.577-.323.854-.127a.6.6 0 01.127.854l-2.99 4.038a.607.607 0 01-.496.254z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol